document.addEventListener('DOMContentLoaded', () => {
    const $navbar = document.getElementById('navbar');
    const $searchForm = document.getElementById('search-form');
    const $searchElements = document.querySelectorAll('.navbar-search-toggle');

    function updateSearchFormPosition() {
        if ($searchForm && $navbar) {
            const navbarHeight = $navbar.offsetHeight;
            if ($searchForm.classList.contains('is-active')) {
                $searchForm.style.opacity = 1;
                $searchForm.style.transform = `translateY(${navbarHeight + 12}px)`;
            } else {
                $searchForm.style.opacity = 0;
                $searchForm.style.transform = 'translateY(-100%)';
            }
        }
    }

    if ($navbar) {
        const observer = new ResizeObserver(() => {
            updateSearchFormPosition();
        });
        observer.observe($navbar);
    }

    if ($searchForm) {
        $searchForm.style.transform = 'translateY(-100%)';
    }

    if ($searchForm && $searchElements) {
        Array.from($searchElements).forEach(($el) => {
            $el.addEventListener('click', () => {
                $searchForm.classList.toggle('is-active');
                document.documentElement.classList.toggle('has-search-open');

                if ($searchForm.classList.contains('is-active')) {
                    $searchForm.querySelector('input').focus();
                    $el.classList.add('is-active');
                    $el.querySelector('.search-label').innerHTML = $el.dataset.closeText;
                } else {
                    $el.classList.remove('is-active');
                    $el.querySelector('.search-label').innerHTML = $el.dataset.searchText;
                }

                updateSearchFormPosition();
            });
        });

        document.addEventListener('click', (event) => {
            let isClickInside = false;

            if ($searchForm.contains(event.target) || Array.from($searchElements).some((element) => element.contains(event.target))) {
                isClickInside = true;
            }

            if (!isClickInside) {
                $searchForm.classList.remove('is-active');
                document.documentElement.classList.remove('has-search-open');

                Array.from($searchElements).forEach(($el) => {
                    $el.classList.remove('is-active');
                    $el.querySelector('.search-label').innerHTML = $el.dataset.searchText;
                });

                updateSearchFormPosition();
            }
        });
    }

    window.addEventListener('scroll', updateSearchFormPosition);
    window.addEventListener('resize', updateSearchFormPosition);
});
